<app-tool-loader [isLoading]="isLoading()">
  <form [formGroup]="form.formGroup">
    <p-panel>
      <ng-template pTemplate="header">
        <div class="flex flex-col items-center m-2 w-full">
          <label class="mr-2 flex-shrink-0">External Pressure</label>
          <div class="flex-1 min-w-0">
            <p-select
              [disabled]="isReadOnly"
              [options]="epps"
              [formControlName]="form.formControlNames.type"
              (onChange)="onEppTypeChange($event)"
              appendTo="body"
            ></p-select>
          </div>
        </div>
      </ng-template>

      <div class="bg-[var(--p-content-background)] p-2">
        @switch (form.formGroup.value.type) {
          @case (ExternalPressureProfileType.CUSTOMEPP) {
            <app-custom-epp
              [formControlName]="form.formControlNames.customEpp"
              [currentString]="currentString"
              [userUnits]="userUnits"
              [wellTd]="wellTd"
              [defaultPressures]="defaultPressures"
            ></app-custom-epp>
          }
          @case (ExternalPressureProfileType.FLUIDTOSHOE) {
            <app-fluid-to-shoe-epp
              [formControlName]="form.formControlNames.fluidToShoeEpp"
              [currentString]="currentString"
              [userUnits]="userUnits"
              [loadCaseIndex]="loadCaseIndex"
            ></app-fluid-to-shoe-epp>
          }
          @case (ExternalPressureProfileType.INTERPOLATIONTOPOREPRSSURE) {
            <app-interpolation-to-pore-pressure-epp
              [formControlName]="form.formControlNames.interpolationToPorePressureEpp"
              [currentString]="currentString"
              [porePressures]="porePressures"
              [shoeDepth]="shoeDepth"
              [userUnits]="userUnits"
              [loadCaseIndex]="loadCaseIndex"
            ></app-interpolation-to-pore-pressure-epp>
          }
          @case (ExternalPressureProfileType.MUDANDCEMENTMIXWATER) {
            <app-mud-and-cement-mix-water-epp
              [formControlName]="form.formControlNames.mudAndCementMixWaterEpp"
              [currentString]="currentString"
              [userUnits]="userUnits"
              [loadCaseIndex]="loadCaseIndex"
            ></app-mud-and-cement-mix-water-epp>
          }
          @case (ExternalPressureProfileType.MUDANDPOREPRESSURE) {
            <app-mud-and-pore-pressure-epp
              [formControlName]="form.formControlNames.mudAndPorePressureEpp"
              [porePressures]="porePressures"
              [shoeDepth]="shoeDepth"
              [currentString]="currentString"
              [userUnits]="userUnits"
              [loadCaseIndex]="loadCaseIndex"
            ></app-mud-and-pore-pressure-epp>
          }
          @case (ExternalPressureProfileType.MUDANDWETCEMENT) {
            <app-mud-and-wet-cement-epp
              [formControlName]="form.formControlNames.mudAndWetCementEpp"
              [cement]="cement"
              [currentString]="currentString"
              [userUnits]="userUnits"
              [loadCaseIndex]="loadCaseIndex"
            ></app-mud-and-wet-cement-epp>
          }
          @case (ExternalPressureProfileType.PERICALLINK) {
            <app-perical-link-epp
              [isReadOnly]="isReadOnly"
              [formControlName]="form.formControlNames.pericalLinkEpp"
              [thermalOperations]="thermalOperations"
              [userUnits]="userUnits"
            ></app-perical-link-epp>
          }
          @case (ExternalPressureProfileType.POREPRESSURE) {
            <app-pore-pressure-epp
              [formControlName]="form.formControlNames.porePressureEpp"
              [porePressures]="porePressures"
              [currentString]="currentString"
              [shoeDepth]="shoeDepth"
              [userUnits]="userUnits"
            ></app-pore-pressure-epp>
          }
          @case (ExternalPressureProfileType.TRAPPEDCASINGPRESSURE) {
            <app-trapped-casing-pressure
              [formControlName]="form.formControlNames.trappedCasingPressureEpp"
              [currentString]="currentString"
              [userUnits]="userUnits"
              [loadCaseIndex]="loadCaseIndex"
              [fracPressures]="fracPressures"
              [tubulars]="tubulars"
            ></app-trapped-casing-pressure>
          }
        }
      </div>

    </p-panel>
  </form>
</app-tool-loader>